"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("Functions/createSvgIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let path = /*#__PURE__*/_react.default.createElement("g", {
  id: "road-sign",
  transform: "translate(-2 -2)"
}, /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2184",
  "data-name": "Trac\xE9 2184",
  d: "M42.141,9.1H40.112V4.028H34.028V9.1H32V3.014A1.014,1.014,0,0,1,33.014,2h8.112a1.014,1.014,0,0,1,1.014,1.014Z",
  transform: "translate(0.422)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2185",
  "data-name": "Trac\xE9 2185",
  d: "M32,27h2.028v5.07H32Z",
  transform: "translate(0.422 0.351)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2186",
  "data-name": "Trac\xE9 2186",
  d: "M41.126,72.309H33.014A1.014,1.014,0,0,1,32,71.3V50h2.028V70.281h6.084V55.07h2.028V71.3A1.014,1.014,0,0,1,41.126,72.309Z",
  transform: "translate(0.422 0.675)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2187",
  "data-name": "Trac\xE9 2187",
  d: "M40,27h2.028v5.07H40Z",
  transform: "translate(0.534 0.351)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2188",
  "data-name": "Trac\xE9 2188",
  d: "M61.576,28.281H21.014A1.014,1.014,0,0,1,20,27.267V9.014A1.014,1.014,0,0,1,21.014,8H50.422v2.028H22.028V26.253H61.187L70.2,18.141l-9.014-8.112h-6.7V8h7.1a1.014,1.014,0,0,1,.678.261L72.4,17.387a1.014,1.014,0,0,1,0,1.507L62.255,28.02A1.014,1.014,0,0,1,61.576,28.281Z",
  transform: "translate(0.253 0.084)",
  fill: "#fff"
}), /*#__PURE__*/_react.default.createElement("path", {
  id: "Trac\xE9_2189",
  "data-name": "Trac\xE9 2189",
  d: "M53.717,51.281H13.155a1.014,1.014,0,0,1-.678-.261L2.336,41.894a1.014,1.014,0,0,1,0-1.507l10.141-9.126A1.014,1.014,0,0,1,13.155,31H53.717a1.014,1.014,0,0,1,1.014,1.014V50.267A1.014,1.014,0,0,1,53.717,51.281ZM13.544,49.253H52.7V33.028H13.544L4.535,41.141Z",
  transform: "translate(0 0.408)",
  fill: "#fff"
}));
let viewBox = '0 0 70.983 70.984';
var _default = exports.default = (0, _createSvgIcon.default)(path, 'OrientationIcon', viewBox);
